import { render, staticRenderFns } from "./searchStyle.vue?vue&type=template&id=65161504&scoped=true"
import script from "./searchStyle.vue?vue&type=script&lang=js"
export * from "./searchStyle.vue?vue&type=script&lang=js"
import style0 from "./searchStyle.vue?vue&type=style&index=0&id=65161504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65161504",
  null
  
)

export default component.exports